import { render, staticRenderFns } from "./HeroDisplay.vue?vue&type=template&id=7c8774e2&scoped=true&"
import script from "./HeroDisplay.vue?vue&type=script&lang=js&"
export * from "./HeroDisplay.vue?vue&type=script&lang=js&"
import style0 from "./HeroDisplay.vue?vue&type=style&index=0&id=7c8774e2&prod&lang=scss&scoped=true&"
import style1 from "./HeroDisplay.vue?vue&type=style&index=1&id=7c8774e2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8774e2",
  null
  
)

export default component.exports